'use client'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { PageWidthText } from '@/components/PageWidth'
import type { AllAuctionsPromoData } from '@/helpers/cms/contentTypes'

const AllAuctionsMarketingContent = ({
  data,
}: {
  /** CMS copy when the marketplace-content flag is on and this section is filled in. */
  data?: AllAuctionsPromoData | null
}) => (
  <PageWidthText>
    <h2>
      {data?.title ?? (
        <FormattedMessage id="Marketing.allAuctionsMarketing.title" />
      )}
    </h2>
    <p>
      {data?.description ?? (
        <FormattedMessage id="Marketing.allAuctionsMarketing.description" />
      )}
    </p>
  </PageWidthText>
)

export default AllAuctionsMarketingContent
